import React from 'react';
export const PrerequisitesErrors = ({ errors }) => {
    if (errors.length === 1) {
        return React.createElement(React.Fragment, null,
            "Your TikTok Shop has been disabled by TikTok due to: ",
            errors[0]);
    }
    return (React.createElement(React.Fragment, null,
        "Your TikTok Shop has been disabled by TikTok due to:",
        ' ',
        React.createElement("ul", null, errors.map((error) => (React.createElement("li", null, error))))));
};
